import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/Button";
import { Type } from "@shared/ui/Type";
import { DownloadICSButton } from "@platform/features/calendarIntegration/components/DownloadICSButton";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";
import { Meeting } from "@platform/types/platform.types";
import ProgramCalendarEventItem from "./ProgramCalendarEventItem";

export type Props = {
  meetings?: Meeting[];
  userTimezone?: TimezoneOption;
  onAddCalendarEvent: (
    meetingId: number | "all",
    calendarType: "google" | "ical"
  ) => void;
};

export function ProgramCalendarEventList({
  meetings,
  userTimezone,
  onAddCalendarEvent,
}: Props) {
  const navigate = useNavigate();

  if (!meetings) return null;

  return (
    <div className="flex flex-col gap-6">
      <Type variant="caption">
        Meeting times are displayed in {userTimezone?.label}.{" "}
        <Button
          variant="link-inline"
          className="underline px-0 inline-block"
          onClick={() => {
            navigate("/account");
          }}
        >
          Edit your profile
        </Button>{" "}
        to select a different timezone.
      </Type>

      {meetings.length > 1 && (
        <div className="flex justify-center self-end">
          <DownloadICSButton
            meetings={meetings}
            eventTitle="Meeting"
            onAddCalendarEvent={onAddCalendarEvent}
          />
        </div>
      )}

      <div className="flex flex-col gap-4">
        {meetings.map((meeting) => (
          <ProgramCalendarEventItem
            key={meeting.id}
            meeting={meeting}
            userTimezone={userTimezone}
            onAddCalendarEvent={onAddCalendarEvent}
          />
        ))}
      </div>
    </div>
  );
}

export default ProgramCalendarEventList;
